<template>
  <div class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
    <div class="bg-gray-900 p-10 rounded-xl text-white max-w-lg w-full text-center shadow-2xl border border-red-600">
      <div class="mb-6">
        <svg class="mx-auto h-16 w-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>
      <h2 class="text-3xl font-bold mb-4 text-red-400">บัญชีของคุณถูกแบน</h2>
      <p class="mb-4 text-gray-200">บัญชีของคุณ (UID: {{ user.uid }}) ถูกระงับการใช้งาน กรุณาติดต่อทีมงานเพื่อขอปลดแบน</p>
      <p class="text-sm text-gray-400">หน้าต่างนี้จะยังคงแสดงอยู่จนกว่าบัญชีของคุณจะได้รับการปลดแบน</p>
      <!-- Sign Out Button -->
      <div class="mt-6">
        <button
          @click="signOut"
          :disabled="isSigningOut"
          class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md shadow-md transition-transform duration-200 flex items-center gap-2 mx-auto"
        >
          <i v-if="isSigningOut" class="fas fa-spinner animate-spin"></i>
          <i v-else class="fas fa-sign-out-alt"></i> ออกจากระบบ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { projectAuth } from '@/firebase/config';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';

export default {
  name: 'BannedModal',
  setup() {
    const { user } = getUser();
    const playerStore = usePlayerStore();
    const isBanned = ref(false);
    const isSigningOut = ref(false);

    watch(() => playerStore.userData, (data) => {
      isBanned.value = data?.ban || false;
    }, { immediate: true });

    // Sign out
    const signOut = async () => {
      isSigningOut.value = true;
      try {
        await projectAuth.signOut();
        window.location.href = '/';
      } catch (err) {
        console.error('Error signing out:', err);
      } finally {
        isSigningOut.value = false;
      }
    };

    return {
      isBanned,
      user,
      signOut,
      isSigningOut
    };
  }
};
</script>

<style scoped>
/* สไตล์เพื่อให้ modal ดูเด่นและป้องกันการคลิกด้านนอก */
.fixed {
  pointer-events: auto;
  backdrop-filter: blur(4px);
}
.bg-gray-900 {
  pointer-events: auto;
  background: linear-gradient(145deg, #1f2937, #111827);
}
.text-gray-200 {
  line-height: 1.6;
}
</style>